import styled from 'styled-components';
import { prem } from 'styles/helpers/spacing';

export const TrimaCadranMainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
`;

/**
 * Sticky mini-bar. Always mounted, fixed height. It sits at the top of the
 * scroll container; opacity/visibility are driven by `data-visible` so the
 * mini fades in once the expanded header scrolls out of view. Because the
 * layout doesn't change when toggling visibility, there is no scroll feedback
 * loop and no flicker.
 */
export const TrimaCadranStickyMini = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${prem(2)};
  padding: ${prem(8)} ${prem(16)};
  background: var(--ion-background-color, #ffffff);
  border-bottom: 1px solid var(--ion-color-light, #e5e5e5);

  /* Reserve a stable height so the sticky region never resizes. */
  min-height: ${prem(56)};

  /* Fade in/out smoothly; visibility hides it from a11y/hit-testing when off. */
  opacity: 0;
  visibility: hidden;
  transition: opacity 160ms ease-out, visibility 0s linear 160ms;

  &[data-visible='true'] {
    opacity: 1;
    visibility: visible;
    transition: opacity 160ms ease-out, visibility 0s linear 0s;
  }

  .trima-mini-counter {
    font-size: ${prem(10)};
    font-weight: 700;
    color: var(--ion-color-primary, #437d76);
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .trima-mini-instruction {
    font-size: ${prem(12)};
    font-weight: 500;
    color: var(--ion-text-color);
    line-height: 1.3;
    overflow: hidden;

    /* stylelint-disable */
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    /* stylelint-enable */
  }
`;

/**
 * Expanded header. Rendered in normal flow — scrolls naturally with the
 * content, leaving the mini-bar behind. Negative margin under the sticky
 * mini so it visually sits at the top on first paint (the sticky mini is
 * invisible there anyway).
 */
export const TrimaCadranExpandedHeader = styled.div`
  /* Pull up under the sticky mini so we don't see its reserved height. */
  margin-top: ${prem(-56)};
  padding-top: ${prem(4)};
  background: var(--ion-background-color, #ffffff);

  .trima-refinement-banner {
    margin: 0 ${prem(16)} ${prem(8)};
    padding: ${prem(10)} ${prem(12)};
    background: var(--ion-color-light, #f4f5f8);
    border-left: ${prem(3)} solid var(--ion-color-medium, #92949c);
    border-radius: ${prem(6)};
    font-size: ${prem(12)};
    font-weight: 400;
    font-style: italic;
    color: #777777;
    line-height: 1.4;
  }

  .trima-cadran-instruction {
    font-size: ${prem(15)};
    font-weight: 400;
    color: var(--ion-text-color);
    line-height: 1.4;
    margin: ${prem(8)} ${prem(16)};
    padding-bottom: ${prem(12)};

    strong {
      display: block;
      font-weight: 700;
      margin-top: ${prem(4)};
    }
  }
`;
